import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'nombre',
    label: i18n('entities.categoriaFormulario.fields.nombre'),
    schema: schemas.string(
      i18n('entities.categoriaFormulario.fields.nombre'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'incluirEstadisticas',
    label: i18n('entities.categoriaFormulario.fields.incluirEstadisticas'),
    schema: schemas.boolean(
      i18n('entities.categoriaFormulario.fields.incluirEstadisticas'),
      {},
    ),
  },
];